export const MONGO_DB_KEYS = {
    B2C_SAME_SESSION: "B2C_SAME_SESSION",
    DIY: "DIY"
};

export const MONGO_DB_CONFIG = {
    [MONGO_DB_KEYS.B2C_SAME_SESSION]: {
        MONGO_RTD_DB_NAME: "b2ccatalog",
        MONGO_RTD_COLLECTION_NAME: "car_recommendation"
    },
    [MONGO_DB_KEYS.DIY]: {
        MONGO_RTD_DB_NAME: "c2b_diy",
        MONGO_RTD_COLLECTION_NAME: "auctionDealerImpressions"
    }
};
